import { get, post, del } from './helper';

export async function cancelOrder(uuid) {
  const res = await del({
    url: `orders/${uuid}`,
    version: 2,
  });
  return res?.data || res;
}

export async function getOrders(payload) {
  const res = await get({
    url: 'orders/history',
    data: payload,
    version: 2,
  });
  return res;
}

export async function getPickupInfo(uuid) {
  const res = await get({
    url: `orders/${uuid}/pickup_info`,
    version: 2,
  });
  return res;
}

export async function sendOrder(mid, data) {
  const res = await post({
    url: `orders/${mid}`,
    version: 2,
    data,
  });
  return res?.data || res;
}

export async function sendSharedOrder(_, data) {
  const res = await post({
    url: 'orders/guest',
    data,
    version: 2,
  });
  return res?.data || res;
}

export default {
  cancelOrder,
  getOrders,
  getPickupInfo,
  sendOrder,
  sendSharedOrder,
};
